<app-loader [isLoading]="isLoading"></app-loader>
<div class="modal-heading">
    <div class="close-button invisible"></div>
    <div class="header-text">All Advance Bills</div>
    <div class="close-button" (click)="closeDialog()">
        <mat-icon class="close-icon">close</mat-icon>
    </div>
</div>

<div class="the_container">
    <div class="table-container">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>
                        <span>Advance Amount</span>
                    </th>
                    <th>
                        <span>Advance Date</span>
                    </th>
                    <th>
                        <span>Description</span>
                    </th>
                </tr>
            </thead>
            <tbody class="table-body">
                @for(row of advanceAmountDetails;track row){
                <tr>
                    <td data-label="advance-amount" >
                        <span>{{formatIndianCurrency(row.advance_amount)}}</span>
                    </td>
                    <td data-label="advance-date">
                        <span>{{row.advance_date}}</span>
                    </td>
                    <td data-label="desc">
                        <span>{{row.description}}</span>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>